exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section[data-v-023bc6c6]{border-radius:1rem;padding:.2rem .8rem;background-color:var(--color-chestnut-rose,#d46a6a)}section>div:first-child>h1[data-v-023bc6c6]{font-size:larger;color:var(--color-white,#fff)}section>div:first-child>div[data-v-023bc6c6]{font-weight:700;margin-left:1rem;background-color:var(--color-white,#fff);color:var(--color-black,#000);padding:.2rem;border-radius:.5rem}section>div[data-v-023bc6c6]:nth-child(2){color:var(--color-white,#fff)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-023bc6c6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Banner.vue
// module id = 460
// module chunks = 0